import { render, staticRenderFns } from "./Expert.vue?vue&type=template&id=345769f5&scoped=true&"
import script from "./Expert.vue?vue&type=script&lang=js&"
export * from "./Expert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345769f5",
  null
  
)

export default component.exports